import { EstadoVerificacion } from '@/shared/model/enumerations/estado-verificacion';

export interface IFiltroVerificaciones {
  cvuCoordinador?: string | null;
  mes?: number | null;
  anio?: number | null;
  estadoActual?: EstadoVerificacion | null;
  tipoVerificacion?: string | null;
}

export class FiltroVerificaciones implements IFiltroVerificaciones {
  constructor(
    public cvuCoordinador?: string | null,
    public mes?: number | null,
    public anio?: number | null,
    public estadoActual?: EstadoVerificacion | null,
    public tipoVerificacion?: string | null,
    public clavesProgramas?: string[] | null
  ) {}
}
